"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_ACTION_PER_RESOURCE = exports.PERMISSION_RESOURCES_ACTIONS = exports.PermissionActionName = exports.PermissionResourceName = exports.PERMISSION_ROLES = exports.PermissionRole = exports.PermissionRoleNames = exports.DEFAULT_USER_PERMISSION_MAP = exports.PermissionAction = exports.PermissionResource = void 0;
exports.getUserPermissionMap = getUserPermissionMap;
exports.hasPermission = hasPermission;
// window is not declared at all in workers, so `typeof` is required to avoid a ReferenceError
const globalWindow = typeof window !== "undefined"
    ? window
    : undefined;
// values need to be named exactly same as backend models/group_permissions.go
var PermissionResource;
(function (PermissionResource) {
    PermissionResource["BranchManagement"] = "branch-management";
})(PermissionResource || (exports.PermissionResource = PermissionResource = {}));
var PermissionAction;
(function (PermissionAction) {
    PermissionAction["View"] = "view";
    PermissionAction["Edit"] = "edit";
})(PermissionAction || (exports.PermissionAction = PermissionAction = {}));
exports.DEFAULT_USER_PERMISSION_MAP = {
    [PermissionResource.BranchManagement]: {
        [PermissionAction.View]: false,
        [PermissionAction.Edit]: false,
    },
};
function getUserPermissionMap() {
    return globalWindow?.__userPermissionMap || exports.DEFAULT_USER_PERMISSION_MAP;
}
// hasPermission returns whether the current user's role is enabled for `action` on `resource`,
// e.g. hasPermission(PermissionResource.BranchManagement, PermissionAction.Edit).
// if only pass in the resource, it will then return true if any of the actions are true
function hasPermission(resource, action) {
    const gpm = getUserPermissionMap();
    const resourcePerms = gpm[resource];
    if (!resourcePerms) {
        return false;
    }
    if (action) {
        return resourcePerms[action] ?? false;
    }
    else {
        for (const permAction in resourcePerms) {
            if (resourcePerms[permAction] === undefined) {
                return false; // this case shouldnt happen, just to make typescript happy
            }
            else if (resourcePerms[permAction]) {
                return true;
            }
        }
        // return false if none of the actions have returned true
        return false;
    }
}
var PermissionRoleNames;
(function (PermissionRoleNames) {
    PermissionRoleNames["admin"] = "\u7BA1\u7406\u8005";
    PermissionRoleNames["shiftLeader"] = "\u30B7\u30D5\u30C8\u7DE8\u96C6\u8005";
    PermissionRoleNames["staff"] = "\u30B9\u30BF\u30C3\u30D5";
    PermissionRoleNames["limitedViewer"] = "\u95B2\u89A7\u8005";
})(PermissionRoleNames || (exports.PermissionRoleNames = PermissionRoleNames = {}));
var PermissionRole;
(function (PermissionRole) {
    PermissionRole["admin"] = "admin";
    PermissionRole["shiftLeader"] = "shift-leader";
    PermissionRole["staff"] = "staff";
    PermissionRole["limitedViewer"] = "limited-viewer";
})(PermissionRole || (exports.PermissionRole = PermissionRole = {}));
// display labels shared with the branch-level permission selector in UsersTable.vue
exports.PERMISSION_ROLES = [
    { name: PermissionRoleNames.admin, value: PermissionRole.admin },
    { name: PermissionRoleNames.shiftLeader, value: PermissionRole.shiftLeader },
    { name: PermissionRoleNames.staff, value: PermissionRole.staff },
    { name: PermissionRoleNames.limitedViewer, value: PermissionRole.limitedViewer },
];
var PermissionResourceName;
(function (PermissionResourceName) {
    PermissionResourceName["branchManagement"] = "\u62E0\u70B9\u7BA1\u7406";
})(PermissionResourceName || (exports.PermissionResourceName = PermissionResourceName = {}));
var PermissionActionName;
(function (PermissionActionName) {
    PermissionActionName["view"] = "\u95B2\u89A7";
    PermissionActionName["editBranch"] = "\u62E0\u70B9\u3092\u7DE8\u96C6";
})(PermissionActionName || (exports.PermissionActionName = PermissionActionName = {}));
exports.PERMISSION_RESOURCES_ACTIONS = [
    {
        name: PermissionResourceName.branchManagement,
        value: PermissionResource.BranchManagement,
        actions: [
            {
                name: PermissionActionName.view,
                value: PermissionAction.View,
            },
            {
                name: PermissionActionName.editBranch,
                value: PermissionAction.Edit,
            },
        ],
    },
];
exports.MAX_ACTION_PER_RESOURCE = exports.PERMISSION_RESOURCES_ACTIONS.reduce((max, resource) => Math.max(max, resource.actions.length), 0);
